module.exports = __webpack_public_path__ + "img/logo.8ede9c4c.svg";